<template>
  <div class="idx-card">
    <div class="idx-card-header idx-bold" :style="showButtonAlertByKey ? 'display: flex; justify-content: space-between;': ''">
      <span v-if="icon" class="mr-2">
        <font-awesome-icon :icon="['fas', `${icon}`]" />
      </span>
      <span>{{ title }}</span>

      <b-form-checkbox v-if="showButtonAlertByKey" v-model="checked" name="check-button" switch>
      </b-form-checkbox>
    </div>

    <div v-if="showFilters" class="col-12 mt-2 pl-0 justify-content">
      <div class="col-6">
        <label class="label-filter">Filtrar por:</label>
        <b-form-select
          class="select-size"
          v-model="selectedOption"
          :options="options"
        ></b-form-select>
      </div>

      <div class="col-6 pr-0">
        <label class="label-filter">Classificar:</label>
        <b-form-select
          class="select-size"
          v-model="order"
          :options="orderItens"
        ></b-form-select>
      </div>
    </div>

    <hr class="mr-3 ml-3 mb-0">

    <div class="idx-card-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import EventBus from '../../../eventBus';

export default {
  props: {
    title: { type: String, required: true },
    icon: { type: String },
    showFilters: {
      type: Boolean,
      default: false,
    },
    showButtonAlertByKey: { type: Boolean, default: false }
  },

  data() {
    return {
      selectedOption: 'all',
      order: 'latest',
      options: [
        { value: null, text: this.$t('answers.answersDetails.treatments.selectFilterTreatments') },
        { value: 'alert', text: this.$t('answers.answersDetails.treatments.systemAlert') },
        { value: 'comment', text: this.$t('answers.answersDetails.treatments.commentFilterTreatments') },
        { value: 'status', text: this.$t('answers.answersDetails.treatments.statusFilterTreatments') },
        { value: 'responsible', text: this.$t('answers.answersDetails.treatments.responsibleFilterTretaments') },
        { value: 'all', text: this.$t('answers.answersDetails.treatments.allFilterTreatments') },
      ],
      orderItens: [
        { value: 'latest', text: this.$t('answers.answersDetails.treatments.mostRecent') },
        { value: 'oldest', text: this.$t('answers.answersDetails.treatments.mostOld') },
      ],
      checked: false,
    };
  },

  watch: {
    selectedOption: function watchActionName(optionValue) {
      EventBus.$emit('update-feed', this.order, optionValue);
    },
    order: function watchActionName(order) {
      EventBus.$emit('update-feed', order, this.selectedOption);
    },
  },
};
</script>

<style lang="scss">
.label-filter {
 font-weight: 700;
}

.justify-content {
  display: flex;
  justify-content: space-between;
}

.bold {
  font-weight: 400;
}

.select-size {
  width: 100%;
}

.idx-card {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-top: 3px solid rgba(0, 0, 0, 0.15);
  max-width: 100%;
  .idx-card-header {
    padding: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }
  .idx-card-body {
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/idx-card/index.vue